import { useMemo } from 'react';
import { Svg } from '@/shared/ui/Svg';
import TrashIcon from '@/shared/assets/icons/trash.svg';

interface IProps {
  file: File;
  handleRemoveFile: (file: File) => void;
}

export const NewFileItem = ({ file, handleRemoveFile }: IProps) => {
  const formattedSize = useMemo(() => {
    const sizeKB = file.size / 1024;
    if (sizeKB < 1024) {
      return `${sizeKB.toFixed(1)} KB`;
    }
    return `${(sizeKB / 1024).toFixed(2)} MB`;
  }, [file.size]);

  return (
    <li
      key={`${file.name}${file.size}`}
      className="flex justify-between items-center gap-2 p-1 bg-neutral-hover rounded-md"
    >
      <span className="min-w-0 truncate" title={file.name}>
        {file.name}
      </span>
      <div className="flex shrink-0 items-center gap-2">
        <span className="whitespace-nowrap text-sm text-grey-secondary">{formattedSize}</span>
        <button type="button" onClick={() => handleRemoveFile(file)} className="cursor-pointer">
          <Svg Icon={TrashIcon} width={18} />
        </button>
      </div>
    </li>
  );
};
